class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    const closeButton = this.querySelector('.modal__close-button, [data-search-close]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    // Prevent duplicate clicks
    if (this.isToggling) return;
    this.isToggling = true;

    event.preventDefault();
    event.stopImmediatePropagation();

    const details = event.target.closest('details');

    if (details) {
      details.hasAttribute('open') ? this.close() : this.open(event);
    }

    setTimeout(() => {
      this.isToggling = false;
    }, 200);
  }

  onBodyClick(event) {
    // 모바일에서 모달이 body로 이동된 경우, 모달 내부 클릭은 무시
    if (this.modalElement && this.modalElement.contains(event.target)) {
      return;
    }
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.classList.add('overflow-hidden');

    // 모바일에서 터치/휠 스크롤 차단
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    document.addEventListener('wheel', this.handleWheel, { passive: false });

    // 헤더가 숨겨진 상태에서도 검색 모달이 보이도록 menu-open 클래스 추가
    this.header = this.header || document.querySelector('.section-header');
    if (this.header) {
      this.header.classList.add('menu-open');
    }

    // 모바일/폴더블에서 모달을 body로 이동 (sticky 부모 문제 해결)
    const modal = this.detailsContainer.querySelector('.search-modal');
    if (modal && window.innerWidth < 900) {
      this.originalParent = modal.parentElement;
      this.modalElement = modal;
      document.body.appendChild(modal);

      // iOS에서 input 포커스 시 자동 스크롤 방지
      const input = modal.querySelector('input:not([type="hidden"])');
      if (input) {
        // preventScroll 옵션으로 포커스
        input.focus({ preventScroll: true });
      }

      // 스크롤 위치 강제 리셋 (여러 번)
      modal.scrollTop = 0;
      setTimeout(() => { modal.scrollTop = 0; }, 0);
      setTimeout(() => { modal.scrollTop = 0; }, 50);
      setTimeout(() => { modal.scrollTop = 0; }, 100);
      setTimeout(() => { modal.scrollTop = 0; }, 200);
    } else {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 100);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
